import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../../utils/basecontext';
import { FlashMessageDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';
import { FlashMessageProcessorFactory } from 'src/com/sixdee/crbtportal/core/processorfactory/flashmessageprocessorfactory';
import { GenerateOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotprequest';
import { GenerateOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotpresponse';
import { GenerateOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/generateotp/generateotpdto';
import { SetFlashMessageRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessagerequest';
import { SetFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessageresponse';
import { FlashSubscriptionDetailsRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsrequest';
import { FlashSubscriptionDetailsResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsresponse';

export interface CreateFlashMessageAPIModel extends APIModel 
{
    setFlashMessage(flashMessageDto: FlashMessageDto): void;
    getSubscriberDetails(flashMessageDto: FlashMessageDto): void;
}

export class CreateFlashMessageAPIModelImpl extends APIModelImpl implements CreateFlashMessageAPIModel 
{
    private flashMessageProcessor: FlashMessageProcessorFactory;
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
        this.flashMessageProcessor = this.getAPIProcesssorFactory().getFlashMessageProcessorFactory();
    }

    getSubscriberDetails(flashMessageDto: FlashMessageDto): void
    {
      this.flashMessageProcessor.getSubscriptionAPIProcessor()
      .success((subscriberValidationResponse: FlashSubscriptionDetailsResponse) => {
        this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
        subscriberValidationResponse.getDescription(), flashMessageDto);
      })
      .failure((subscriberValidationResponse: FlashSubscriptionDetailsResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new FlashSubscriptionDetailsRequestImpl(flashMessageDto.getMsisdn()));
    }

    setFlashMessage(flashMessageDto: FlashMessageDto): void
    {
      let generateOtp = new GenerateOTPDtoImpl();
      generateOtp.setMsisdn(flashMessageDto.getMsisdn());
      
      this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().generateOTP()
                .success((generateOTPResponse : GenerateOTPResponse)=>
                {
                  this.flashMessageProcessor.setFlashMessageAPIProcessor()
                  .success((subscriberValidationResponse: SetFlashMessageResponse) => {
                    this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
                    subscriberValidationResponse.getDescription(), subscriberValidationResponse);
                  })
                  .failure((subscriberValidationResponse: SetFlashMessageResponse) => {
                      this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                          subscriberValidationResponse.getDescription(), subscriberValidationResponse);
                  })
                  .execute(new SetFlashMessageRequestImpl(flashMessageDto));
                })
                .failure((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                         generateOTPResponse.getDescription(), generateOTPResponse);

                }).execute(new GenerateOTPRequestImpl(generateOtp));
      
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/createflashmessage/createflashmessageapimodel.tsx